import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity'
import { createReducer, on, Action } from '@ngrx/store'

import * as ProfilesActions from './profiles.actions'
import { VolunteerProfileEntity } from './profiles.models'

export const PROFILES_FEATURE_KEY = 'profiles'

export interface ProfileState extends EntityState<VolunteerProfileEntity> {
  loaded: boolean // has the Profiles list been loaded
  count: number
}

export interface ProfilesPartialState {
  readonly [PROFILES_FEATURE_KEY]: ProfileState
}

export const profilesAdapter: EntityAdapter<VolunteerProfileEntity> = createEntityAdapter<VolunteerProfileEntity>({
  selectId: (profile: VolunteerProfileEntity) => profile.uuid,
  sortComparer: (a: VolunteerProfileEntity, b: VolunteerProfileEntity) => {
    if (!a.first_name) return 1
    if (!b.first_name) return -1
    // sort profiles by alphabetical order
    return a?.first_name.localeCompare(b?.first_name)
  },
})

export const initialState: ProfileState = profilesAdapter.getInitialState({
  // set initial required properties
  error: '',
  loaded: true,
  count: 0,
})

export const ProfileReducer = createReducer(
  initialState,
  on(ProfilesActions.loadProfilesVolunteer, (state) => ({
    ...state,
    loaded: false,
  })),
  on(ProfilesActions.loadProfilesVolunteerSuccess, (state, action) =>
    profilesAdapter.setAll(action.profiles, {
      ...state,
      loaded: true,
      count: action.count,
    }),
  ),

  on(ProfilesActions.clearProfiles, () => initialState),
)

export function reducer(state: ProfileState | undefined, action: Action) {
  return ProfileReducer(state, action)
}
